import type {
  BranchUI,
  Coords,
} from '@/common/types/vip-vendor-contact-us.type';
import type { LatLngTuple } from 'leaflet';

import type { responseItem } from '@/common/apis/dedicated-personal-page/contact-us.api';

export const mapToUI = (
  items: responseItem[],
  fallback: Coords,
  zoom = 16
): BranchUI[] =>
  (items ?? []).map((b) => {
    const center: Coords = b.location
      ? [b.location.lat, b.location.lng]
      : fallback;
    const hasMap = !!b.location;

    return {
      id: String(b.id),
      isActive: b.isActive,
      title: b.title?.trim(),
      address: b.address || undefined,
      mobiles: b.mobiles?.length ? b.mobiles : undefined,
      phones: b.tels?.length ? b.tels : undefined,
      faxs: b.faxs?.length ? b.faxs : undefined,
      emails: b.emails?.length ? b.emails : undefined,
      faceToFaceSales: !!b.faceToFaceSales,
      hasMap,
      mapCenter: center as LatLngTuple,
      mapPins: hasMap ? [center] : undefined,
      mapZoom: zoom,
    };
  });
